export const ROOM_STAGE_MEDIA_LAYOUT = {
  // media only
  Media: "media",
  // media and >1 commenters
  MediaSidebar: "media-sidebar",
  // media and 1 commenter
  MediaSidebar1: "media-sidebar-1"
} as const;
export const ROOM_STAGE_LAYOUT = {
  ...ROOM_STAGE_MEDIA_LAYOUT,
  FullScreen: "full-screen",
  Grid: "grid",
  Sidebar: "sidebar"
} as const;

export const ROOM_STAGE_MEDIA_LAYOUTS = Object.values(ROOM_STAGE_MEDIA_LAYOUT);
export const ROOM_STAGE_LAYOUTS = Object.values(ROOM_STAGE_LAYOUT);
